import { defineSlotRecipe } from '@chakra-ui/react';
import { Colors, TextStyles, FontWeights, Space } from '../../types';

/** The `field` slot recipe styles the form control, its label, helper text and error text. */
export const fieldSlotRecipe = defineSlotRecipe({
  slots: ['root', 'label', 'requiredIndicator', 'helperText', 'errorText', 'errorIcon'],
  base: {
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      position: 'relative',
      gap: Space['2XS'],
      _notFirst: { mt: Space.MD },
    },
    label: {
      '&:is(label)': { textStyle: TextStyles.UI_DEFAULT },
      fontWeight: FontWeights.MEDIUM,
      display: 'flex',
      alignItems: 'baseline',
      alignSelf: 'center',
      color: Colors.TEXT_EMPHASIS,
      flexWrap: 'wrap',
      me: Space['2XS'],
      mb: Space['2XS'],
      gap: Space['2XS'],
      _disabled: {
        opacity: 1,
      },
      '& legend': {
        fontWeight: FontWeights.SEMIBOLD,
        textStyle: TextStyles.P1,
        color: Colors.TEXT_EMPHASIS,
        mb: Space.XS,
      },
    },
    requiredIndicator: {
      color: Colors.TEXT_ERROR,
      ms: Space['2XS'],
    },
    helperText: {
      display: 'block',
      color: Colors.TEXT_SUBDUED,
      textStyle: TextStyles.P3,
      mt: 0,
      mb: Space['2XS'],
      '&:last-child': {
        mt: Space['2XS'],
      },
    },
    errorText: {
      display: 'inline-flex',
      alignItems: 'center',
      fontWeight: FontWeights.MEDIUM,
      color: Colors.TEXT_ERROR,
      textStyle: TextStyles.UI_COMPACT,
      my: Space.XS,
      gap: Space.XS,
      ps: Space['2XS'],
    },
    errorIcon: {
      fontSize: '1.125em',
      boxSize: '1lh',
      color: Colors.ICON_ERROR,
      me: 0,
    },
  },
  variants: {
    orientation: {
      // Fields span the row: stock's default vertical `flex-start` would shrink-wrap the wrapper child.
      vertical: {
        root: {
          alignItems: 'stretch',
          // Stretching the switch root would widen the toggle's click target to the whole row.
          '& > [data-scope=switch][data-part=root]': { alignSelf: 'flex-start' },
        },
      },
    },
  },
});
